"use client";

export function ProblemBanner({ message }: { message: string }) {
  return (
    <div className="sticky top-0 z-50 bg-gray-900 px-6 py-2.5 sm:px-3.5">
      <p className="mx-auto w-fit text-sm leading-6 text-white">{message}</p>
    </div>
  );
}
